import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { AppleDevice } from '../../snippets/appleDevice/appleDevice';

class Navigation {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-nav',
            mainItemsAttr: 'main-items',
            mainItemToggleAttr: 'main-toggle',
            rootToggleAttr: 'root-toggle',
            toggleAttr: 'toggle',
            scrollerAttr: 'scroller',
            subNavAttr: 'sub',
            subItemsAttr: 'sub-items'
        };

        this.settings = Object.assign({}, defaults, options);

        this.$navigation = element;
        this.$navigationToggle = document.querySelector('[' + this.settings.initAttr + '="' + this.settings.rootToggleAttr + '"]');
        this.$navigationScroller = this.$navigation.querySelector('[' + this.settings.initAttr + '="' + this.settings.scrollerAttr + '"]');

        this.initialize();
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.$navigationToggle.addEventListener('change', () => {
            if (this.$navigationToggle.checked === true) {
                if (!window.Modernizr.csshover) {
                    disableBodyScroll(this.$navigationScroller);
                }
            } else {
                if (!window.Modernizr.csshover) {
                    enableBodyScroll(this.$navigationScroller);
                }
            }
        });

        // hide apple payment icon if not apple device
        const appleDevice = new AppleDevice();
        appleDevice.hidePaymentIconApple();
    }
}

export { Navigation };
